// assets/bm-blogs.js
(function(){
  const $  = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));
  const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ========= GA4 Helper (falls GA4 noch nicht ready ist) ========= */
  window.bmTrack = window.bmTrack || function(name, params){
    try { gtag('event', name, params || {}); } catch(e) {}
  };

  /* ========= Delegated CTA-Tracking ========= */
  document.addEventListener('click', function(e){
    const el = e.target.closest('[data-bm-cta]');
    if(!el) return;
    const type  = el.getAttribute('data-bm-cta'); // product | collection | in_article
    const label = el.getAttribute('data-bm-label') || (el.textContent || '').trim().slice(0,60);
    const pid   = el.getAttribute('data-bm-product') || undefined;

    const eventName =
      type === 'product'    ? 'blog_to_product_click' :
      type === 'collection' ? 'blog_to_collection_click' :
                               'in_article_cta_click';

    bmTrack(eventName, { label, product_id: pid, page_location: location.href });
  });

  /* ========= Scroll-Depth 75% ========= */
  (function(){
    let fired=false;
    function onScroll(){
      if(fired) return;
      const scrolled=(window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
      if(scrolled >= 0.75){
        fired=true;
        bmTrack('scroll_75', { page_location: location.href });
        window.removeEventListener('scroll', onScroll);
      }
    }
    window.addEventListener('scroll', onScroll, {passive:true});
  })();

  document.addEventListener('DOMContentLoaded', function () {

    /* ========= FAQ Toggle (A11y-first; funktioniert mit/ohne .faq-item) ========= */
    (function initFAQ(){
      let items = $$('.faq-item');
      if (!items.length) {
        // Fallback: baue Items aus .faq-question und der jeweils nächsten .faq-answer
        const qs = $$('.faq-question');
        items = qs.map((btn, i) => {
          let ans = btn.nextElementSibling;
          while (ans && !ans.classList?.contains('faq-answer')) ans = ans.nextElementSibling;
          return { _synthetic: true, el: btn.parentElement || document.body, btn, ans, i };
        }).filter(x => x.btn && x.ans);
      } else {
        // Normalfall mit Wrapper
        items = items.map((item, i) => ({ el:item, btn:$('.faq-question', item), ans:$('.faq-answer', item), i }));
      }
      if (!items.length) return;

      items.forEach(({el, btn, ans, i}) => {
        if (!btn || !ans) return;

        // Fallback-IDs
        if (!btn.id) btn.id = `faq-question-${i}`;
        if (!ans.id) ans.id = `faq-answer-${i}`;

        // A11y-Attribute
        btn.setAttribute('role', 'button');
        if (!btn.hasAttribute('tabindex')) btn.setAttribute('tabindex', '0');
        btn.setAttribute('aria-controls', ans.id);
        btn.setAttribute('aria-expanded', 'false');
        ans.setAttribute('aria-labelledby', btn.id);
        ans.setAttribute('aria-hidden', 'true');
        ans.hidden = true;

        const closeAll = () => {
          items.forEach(({btn:b, ans:a}) => {
            if (!b || !a) return;
            b.classList.remove('open');
            b.setAttribute('aria-expanded', 'false');
            a.setAttribute('aria-hidden', 'true');
            a.hidden = true;
          });
        };

        const openThis = () => {
          btn.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
          ans.setAttribute('aria-hidden', 'false');
          ans.hidden = false;
        };

        const toggle = () => {
          const isOpen = btn.classList.contains('open');
          closeAll();
          if (!isOpen) openThis();
        };

        btn.addEventListener('click', toggle);
        btn.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        });
      });
    })();

    /* ========= Poll ========= */
    (function initPoll(){
      const submitBtn   = $('#poll-submit');
      const pollForm    = $('#poll-form');
      const pollResults = $('#poll-results');
      const pollThanks  = $('#poll-thankyou');
      if (!submitBtn || !pollForm || !pollResults || !pollThanks) return;

      // Ergebnisbalken (aus Prozent-Text)
      function updatePollBars() {
        $$('.poll-result').forEach((row, i) => {
          const span = row.querySelector(`#result${i}`);
          const bg   = row.querySelector('.poll-bar-bg');

          let percent = 0;
          if (span) {
            const txt = (span.textContent || '').replace(',', '.').replace(/[^\d.]/g, '');
            percent = Math.max(0, Math.min(100, parseFloat(txt) || 0));
          }

          let bar = row.querySelector(`#bar${i}`);
          if (!bar && bg) {
            bar = document.createElement('div');
            bar.className = 'poll-bar';
            bar.id = `bar${i}`;
            if (prefersReduced) bar.style.transition = 'none';
            bg.appendChild(bar);
          }

          requestAnimationFrame(() => {
            if (bar) bar.style.width = percent + '%';
            if (bg) {
              bg.classList.add('filled');
              bg.style.setProperty('--pct', percent + '%');
            }
          });
        });
      }

      // Key für localStorage
      const questionEl = $('.poll-block p strong') || $('.poll-block h2');
      const pollKey = 'bm_poll_' + (questionEl ? (questionEl.textContent || 'q').trim() : 'q');

      function showResultsMode() {
        pollForm.style.display = 'none';
        pollResults.style.display = 'block';
        pollThanks.style.display  = 'block';
        updatePollBars();
        $$('input[name="poll"]').forEach(i => { i.disabled = true; });
      }

      // Bereits abgestimmt?
      if (localStorage.getItem(pollKey) === 'voted') {
        showResultsMode();
        return;
      }

      // Initial: ausblenden
      pollResults.style.display = 'none';
      pollThanks.style.display  = 'none';

      submitBtn.addEventListener('click', function () {
        const chosen = $('input[name="poll"]:checked');
        if (!chosen) return;

        const idx = parseInt(chosen.value, 10);

        // Prozentwerte einsammeln
        let results = [];
        $$('[id^=result]').forEach((span) => {
          const num = parseFloat((span.textContent || '').replace(',', '.').replace(/[^\d.]/g, '')) || 0;
          results.push(Math.max(0, Math.min(100, num)));
        });

        // +1 für gewählte Option (Pseudo-Stimme)
        results[idx] = (results[idx] || 0) + 1;

        // Auf 100 % normieren
        const sum = results.reduce((a, b) => a + b, 0) || 1;
        results = results.map(x => Math.round((100 * x) / sum));
        // Rundungsrest
        const rest = 100 - results.reduce((a, b) => a + b, 0);
        if (rest !== 0) {
          const best = results.indexOf(Math.max(...results));
          results[best] = Math.max(0, Math.min(100, results[best] + rest));
        }

        // In DOM schreiben
        $$('[id^=result]').forEach((span, i) => {
          const val = Math.max(0, Math.min(100, results[i] || 0));
          span.textContent = val + '%';
          const bar = document.getElementById(`bar${i}`);
          if (bar) bar.style.width = val + '%';
        });

        // Sicht umschalten
        pollForm.style.display = 'none';
        pollResults.style.display = 'block';
        pollThanks.style.display  = 'block';

        updatePollBars();
        localStorage.setItem(pollKey, 'voted');
        $$('input[name="poll"]').forEach(i => { i.disabled = true; });
      });

      updatePollBars();
    })();

  }); // DOMContentLoaded
})();
